import React, { lazy } from "react";
import { Loader } from "../../root/loader";
const CslDashboard = lazy(() => import("./components/csldashboard"));

export const csldashboard = () => [
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/csl",
            element: (
                <Loader>
                    <CslDashboard />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/csl/:workspaceId",
            element: (
                <Loader>
                    <CslDashboard />
                </Loader>
            )
        }
    }
];
